import React, { Component } from 'react';
import Firebase from 'firebase';
import Moment from 'moment';
import 'moment/locale/es';
import Connector from '../../data/Connector';
import HelperClients from '../../helper/Clients';
import HelperBusiness from '../../helper/Business';
import HelperCal from '../../helper/Calendar';
import HelperEmpty from '../../helper/Empty';
import { Link, withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import EventEmitter from '../../helper/Emitter';
import Navigation from '../../components/Navigation';
import Header from '../../components/Headers/clientdetails';
import ListHeader from '../../components/List/header';
import ListEmpty from '../../components/List/empty';
import WidgetChartGraph from '../../components/Widgets/chart-graph';
import WidgetChartBar from '../../components/Widgets/chart-bar';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';




class ClientsProgressPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      item: null,
      name: 'Client',
      sessions: global.sessions,
      archive: global.archive,
      sessionsTraining: global.sessionsTraining,
      archiveTraining: global.archiveTraining,
      best: [],
      dateRange: global.dateRange,
      showModalDay: false,
      hiddenDay: 'hidden',
      cbest: null,
      margin: 0,
      ltitle: 'Weights (kg)',
      dataLeft: [
        {
          "id": "japan",
          "color": "#1DC5C9",
          "data": []
        },
      ],
      currentLeft: '',
      dataRight: [
        {
          "id": "japan",
          "color": "#81DB24",
          "data": []
        },
      ],
      currentRight: 'fat',
      showModalBeep: false,
      hiddenBeep: 'hidden',
      beep: [],
      beep1: '00',
      beep2: '00',
      dataEnergy: [
        {
          "id": "japan",
          "color": "#81DB24",
          "data": []
        },
      ],
      benchmark: [],
      energy1: '-',
      energy2: '-',
      month: Moment().format('MM/YYYY'),
      day: Moment().format('DD/MM/YYYY'),
      days: [],
      selected: [],
      dsessions: [],
      // Current movement
      exid: '',
      exname: '',
      current: null,
      search: '',
      variations: [],
      showSearch: false,
      // Graph
      gc: "#1DC5C9",
      showWeight: true,
      showReps: false,
      date1: Moment().add(-1, 'years').format('YYYY-MM-DD'),
      date2: Moment().format('YYYY-MM-DD'),
    };
  }


  componentDidMount() { 
    HelperPage.initialize('Progress - Client Details - PT Mate', global.currentPage)
    HelperPage.checkMessage()
    this._isMounted = true

    EventEmitter.subscribe('clientsLoaded', (event) => {
      this.getClient()
      if(this.state.id === '') {
        this.getEmpty()
      }
    })
    EventEmitter.subscribe('sessionsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('archiveLoaded', (event) => this.configureData())
    if(this.state.sessionsTraining.length === 0) {
      setTimeout(() => {
        this.updateTraining();
      }, 5000);
    }
    EventEmitter.subscribe('exercisesLoaded', (event) => this.configureData())
    EventEmitter.subscribe('bestLoaded', (event) => this.configureData())
    this.getEmpty()

    var tmp = []
    for(var i=0; i<20; i++) {
      if(i < 10) {
        tmp.push('0'+i)
      } else {
        tmp.push(i)
      }
    }
    this.setState({
      beep: tmp,
    })
    this.configureData()

    if(global.archive.length === 0 && global.uidUser !== '') {
      Connector.loadArchive((result) => {})
    }

    if(global.spaceTheme === 'red') {
      this.setState({
        gc: "#DE1053"
      })
    }
  }


  componentWillUnmount() {
    this._isMounted = false
    EventEmitter.unsubscribe('clientsLoaded', () => {})
    EventEmitter.unsubscribe('sessionsLoaded', () => {})
    EventEmitter.unsubscribe('archiveLoaded', () => {})
    EventEmitter.unsubscribe('exercisesLoaded', () => {})
    EventEmitter.unsubscribe('bestLoaded', () => {})
  }


  getEmpty() {
    if(this._isMounted) {
      var arr = this.props.location.pathname.split('/')
      global.currentClient = arr[arr.length-2]
      this.getClient()
    }
  }


  updateTraining() {
    this.setState({
      sessionsTraining: global.sessionsTraining,
      archiveTraining: global.archiveTraining,
    })
    if(this.state.sessionsTraining.length === 0) {
      setTimeout(() => {
        this.updateTraining();
      }, 5000);
    }
  }


  getClient() {
    if(this._isMounted) {
      var id = ''
      var name = ''
      var item = null
      global.clientBest = []
      for(var client of global.clients) {
        if(client.id === global.currentClient) {
          if(client.data.uid !== '') {
            Connector.loadClientBest(client.data.uid)
          } else {
            Connector.loadClientBest(client.id)
          }
          
          id = client.id
          item = client
          name = item.data.name
        }
      }

      if(item !== null) {
        this.setState({
          id: id,
          item: item,
          name: name,
        }, () => {
            this.configureData()
            global.linkCli = '/clients/'+id+'/progress';
        });
      }
    }    
  }


  configureData() {
    if(this._isMounted) {
      var tmp = []
      var tmp4 = []
      var ids = []

      var tmp11 = this.state.exid
      var tmp12 = this.state.exname
      var tmp13 = null
      if(global.exercises.length > 0 && this.state.exid === '') {
        var unit = 'reps'
        if(global.exercises[0].data.subUnits !== undefined) {
          unit = global.exercises[0].data.subUnits[0]
        }
        tmp11 = global.exercises[0].data.subIds[0]
        tmp12 = global.exercises[0].data.subTitles[0]
        tmp13 = {
          id: global.exercises[0].data.subIds[0],
          name: global.exercises[0].data.subTitles[0],
          tool: global.exercises[0].data.subTools[0],
          image: global.exercises[0].data.subImages[0],
          cat: global.exercises[0].data.cat,
          type: global.exercises[0].data.type,
          reps: 0,
          weight: 0,
          wmin: 0,
          wsec: 0,
          rmin: 0,
          rsec: 0,
          weighttype: (global.spaceLbs ? 'lb' : 'kg'),
          unit: unit,
          notes: "",
        }
      }

      // Sessions with trainer
      for(var item of global.sessions) {
        var isGroup = false
        if(item.data.group && item.data.clients !== undefined) {
          if(item.data.clients.indexOf(global.currentClient) !== -1) {
            isGroup = true
          }
        }
        if(Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('X') < Moment().format('X') && Moment(item.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
          if(item.data.client === this.state.id) {
            tmp.push(item)
          }
          if(isGroup) {
            tmp.push(item)
          }
        }
        if(item.program.length > 0 && (isGroup || item.data.client === this.state.id)) {
          if(item.program[0].data.benchmark === true) {
            if(ids.indexOf(item.program[0].id) === -1) {
              ids.push(item.program[0].id)
              tmp4.push(item.program[0])
            }
          }
        }
      }
      for(var item2 of global.archive) {
        if(item2.data.client === this.state.id && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
          tmp.push(item2)
        }
        var isGroup2 = false
        if(item2.data.group && item2.data.clients !== undefined) {
          if(item2.data.clients.indexOf(global.currentClient) !== -1) {
            isGroup2 = true
          }
        }
        if(isGroup2 && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
          tmp.push(item2)
        }
        if(item2.program.length > 0 && (isGroup2 || item2.data.client === this.state.id)) {
          if(item2.program[0].data.benchmark === true) {
            if(ids.indexOf(item2.program[0].id) === -1) {
              ids.push(item2.program[0].id)
              tmp4.push(item2.program[0])
            }
          }
        }
      }

      // Training sessions
      if(this.state.item !== null && (this.state.show === 'all' || this.state.show === 'training')) {
        for(var item3 of global.sessionsTraining) {
          if(item3.data.client === this.state.item.data.uid && Moment(item3.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item3.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
            tmp.push(item3)
            if(item3.program[0].data.benchmark === true) {
              if(ids.indexOf(item3.program[0].id) === -1) {
                ids.push(item3.program[0].id)
                tmp4.push(item3.program[0])
              }
            }
          }
        }
        for(var item4 of global.archiveTraining) {
          if(item4.data.client === this.state.item.data.uid && Moment(item4.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item4.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
            tmp.push(item4)
            if(item4.program[0].data.benchmark === true) {
              if(ids.indexOf(item4.program[0].id) === -1) {
                ids.push(item4.program[0].id)
                tmp4.push(item4.program[0])
              }
            }
          }
        }
      }

      var bp = '00:00'
      if(this.state.item !== null) {
        if(this.state.item.data.beep !== undefined) {
          bp = this.state.item.data.beep
        }
      }
      
      var ar = bp.split(':')

      var tmp2 = []
      for(var item5 of global.clientBest) {
        for(var ex of global.exercises) {
          if(ex.data.subIds.indexOf(item5.id) !== -1 && ids.indexOf(item5.id) === -1 && global.exToolsWeight.indexOf(item5.data.tool) !== -1) {
            tmp2.push(item5)
            ids.push(item5.id)
          }
        }
      }
      
      this.setState({
        sessions: tmp,
        sessionsTraining: global.sessionsTraining,
        archiveTraining: global.archiveTraining,
        best: tmp2,
        beep1: ar[0],
        beep2: ar[1],
        benchmark: tmp4,
        exid: tmp11,
        exname: tmp12,
        current: tmp13,
        //ltitle: this.state.cbest === null ? lang.t('clients:label.weights') : lang.t('clients:label.weights')+' ('+this.renderExType(this.state.cbest.data.type)+')',
      }, () => {
        if(tmp2.length > 0) {
          this.setState({
            currentLeft: tmp2.id
          })
          var id = tmp2[0].id
          if(this.state.cbest === null) {
            for(var it of tmp2) {
              if(it.id === this.state.cbest) {
                id = this.state.cbest
              }
            }
          }
          this.createGraphWeights(tmp11)
          this.configureDetails(tmp11)
        }
        this.createGraphEnergy()
      })
    }
  }


  configureBestName(item) {
    var label = item.data.name
    if(item.data.tool === 6 || item.data.tool === 7) {
      var ar = item.id.split('|')
      if(ar.length > 1) {
        label = item.data.name+' '+ar[1]+' m'
      }
    }
    return label
  }


  configureDetails(ex) {
    var best = null
    for(var item of this.state.best) {
      if(item.id === ex) {
        best = item
      }
    }
    this.setState({
      cbest: best,
    })
  }


  filterExercises(value) {
    var tmp = []
    var tags = []
    if(value === '') {
      for(var item of global.exercises) {
        for(var i=0; i<item.data.subTitles.length; i++) {
          var unit = 'reps'
          if(item.data.subUnits !== undefined) {
            unit = item.data.subUnits[i]
          }
          tmp.push({
            id: item.data.subIds[i],
            name: item.data.subTitles[i],
            tool: item.data.subTools[i],
            image: item.data.subImages[i],
            cat: item.data.cat,
            type: item.data.type,
            reps: 0,
            weight: 0,
            wmin: 0,
            wsec: 0,
            rmin: 0,
            rsec: 0,
            weighttype: (global.spaceLbs ? 'lb' : 'kg'),
            unit: unit,
            notes: "",
          })
        }
      }
      this.setState({
        variations: tmp,
        search: ''
      })
    } else {
      var str = value.toLowerCase()
      for(var item2 of global.exercises) {
        tags = []
        if(item2.data.subTags !== undefined) {
          tags = item2.data.subTags
        }
        for(var i2=0; i2<item2.data.subTitles.length; i2++) {
          var title = item2.data.subTitles[i2].toLowerCase()
          if(title.indexOf(str) !== -1) {
            var unit2 = 'reps'
            if(item2.data.subUnits !== undefined) {
              unit2 = item2.data.subUnits[i2]
            }
            tmp.push({
              id: item2.data.subIds[i2],
              name: item2.data.subTitles[i2],
              tool: item2.data.subTools[i2],
              image: item2.data.subImages[i2],
              cat: item2.data.cat,
              type: item2.data.type,
              reps: 0,
              weight: 0,
              wmin: 0,
              wsec: 0,
              rmin: 0,
              rsec: 0,
              weighttype: (global.spaceLbs ? 'lb' : 'kg'),
              unit: unit2,
              notes: "",
            })
          }
        }
      }
      this.setState({
        variations: tmp,
        search: value
      })
    }
  }




  // Graph Calculations ------------------------------------------------------------



  setDateStart(event) {
    var dt = Moment(event.target.value+' 23:59', 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
    this.setState({
        date1: dt
    })
  }


  setDateEnd(event) {
    var dt = Moment(event.target.value+' 23:59', 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')
    this.setState({
        date2: dt
    })
  }


  setDates() {
    // Sessions with trainer
    var tmp = []
    var tmp4 = []
    var ids = []

    for(var item of global.sessions) {
      var isGroup = false
      if(item.data.group && item.data.clients !== undefined) {
        if(item.data.clients.indexOf(global.currentClient) !== -1) {
          isGroup = true
        }
      }
      if(Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('X') < Moment().format('X') && Moment(item.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
        if(item.data.client === this.state.id) {
          tmp.push(item)
        }
        if(isGroup) {
          tmp.push(item)
        }
      }
      if(item.program.length > 0 && (isGroup || item.data.client === this.state.id)) {
        if(item.program[0].data.benchmark === true) {
          if(ids.indexOf(item.program[0].id) === -1) {
            ids.push(item.program[0].id)
            tmp4.push(item.program[0])
          }
        }
      }
    }
    for(var item2 of global.archive) {
      if(item2.data.client === this.state.id && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
        tmp.push(item2)
      }
      var isGroup2 = false
      if(item2.data.group && item2.data.clients !== undefined) {
        if(item2.data.clients.indexOf(global.currentClient) !== -1) {
          isGroup2 = true
        }
      }
      if(isGroup2 && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item2.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
        tmp.push(item2)
      }
      if(item2.program.length > 0 && (isGroup2 || item2.data.client === this.state.id)) {
        if(item2.program[0].data.benchmark === true) {
          if(ids.indexOf(item2.program[0].id) === -1) {
            ids.push(item2.program[0].id)
            tmp4.push(item2.program[0])
          }
        }
      }
    }

    // Training sessions
    if(this.state.item !== null && (this.state.show === 'all' || this.state.show === 'training')) {
      for(var item3 of global.sessionsTraining) {
        if(item3.data.client === this.state.item.data.uid && Moment(item3.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item3.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
          tmp.push(item3)
          if(item3.program[0].data.benchmark === true) {
            if(ids.indexOf(item3.program[0].id) === -1) {
              ids.push(item3.program[0].id)
              tmp4.push(item3.program[0])
            }
          }
        }
      }
      for(var item4 of global.archiveTraining) {
        if(item4.data.client === this.state.item.data.uid && Moment(item4.data.date, 'DD/MM/YYYY HH:mm') >= Moment(this.state.date1, 'YYYY-MM-DD') && Moment(item4.data.date, 'DD/MM/YYYY HH:mm') <= Moment(this.state.date2, 'YYYY-MM-DD')) {
          tmp.push(item4)
          if(item4.program[0].data.benchmark === true) {
            if(ids.indexOf(item4.program[0].id) === -1) {
              ids.push(item4.program[0].id)
              tmp4.push(item4.program[0])
            }
          }
        }
      }
    }
    this.setState({
      sessions: tmp,
      benchmark: tmp4,
    }, () => {
      this.createGraphWeights(this.state.exid)
    })
  }


  setDateRange(event) {
    global.dateRange = event.target.value
    this.setState({
        dateRange: event.target.value
    }, () => {
        this.createGraphEnergy()
    });
  }


  showSessions(event) {
     this.setState({
        show: event.target.value
    }, () => {
        this.configureData()
    });
  }


  setMonth(type) {
    var dt = Moment('01/'+this.state.month, 'DD/MM/YYYY').add(1, 'month')
    if(type === 'prev') {
      dt = Moment('01/'+this.state.month, 'DD/MM/YYYY').add(-1, 'month')
    }
    this.setState({
      month: Moment(dt).format('MM/YYYY')
    })
  }


  toggleGraph(type) {
    if(type === 'weight') {
      this.setState({
        showWeight: !this.state.showWeight
      }, () => {
        this.createGraphWeights(this.state.current.id)
      })
    } else {
      this.setState({
        showReps: !this.state.showReps
      }, () => {
        this.createGraphWeights(this.state.current.id)
      })
    }
  }


  createGraphWeights(id) {
    var hasWeight = false
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        hasWeight = true
      }
    }

    var tmp = []
    var tmpr = []
    var days = []
    var sessions = []
    var list = this.state.sessions
    list.sort((a,b) => Moment(a.data.date, 'DD/MM/YYYY HH:mm') - Moment(b.data.date, 'DD/MM/YYYY HH:mm'));
    
    for(var item of list) {
      var numbr = 0
      if(item.program[0] !== undefined) {
        if(item.program[0].id !== '') {
          
          for(var block of item.program[0].blocks) {
            for(var i=0; i<block.data.exId.length; i++) {
              if(block.data.exId[i] === id) {
                days.push(Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY'))
                numbr++
                var label = ''
                var valr = 0
                if(!item.data.group) {
                  var val = block.data.exResWeight[i]
                  var wval = val
                  var reps = 0
                  if(block.data.exResReps !== undefined) {
                    reps = block.data.exResReps[i]
                    valr = block.data.exResReps[i]
                  }
                  if(block.data.exResWeightRounds !== undefined) {
                    wval = block.data.exResWeightRounds[i]
                  }
                  if(block.data.exResRepsRounds !== undefined) {
                    reps = block.data.exResRepsRounds[i]
                  }
                  sessions.push({
                    id: item.id,
                    name: lang.t('clients:label.11session'),
                    type: block.data.type,
                    date: item.data.date,
                    weight: wval,
                    reps: reps,
                    block: block,
                    weightType: block.data.exWeightType[i]
                  })
                  if(val === undefined) {
                    val = 0
                  }
                  
                  if(numbr > 1) {
                    label = ' ('+numbr+')'
                  }
                  if(val !== 0) {
                    tmp.push({
                      "x": Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('D MMM YYYY')+label,
                      "y": val,
                    })
                    tmpr.push({
                      "x": Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('D MMM YYYY')+label,
                      "y": valr,
                    })
                  }
                } else {
                  var num = 0
                  if(item.data.clients !== undefined && item.data.clients.length > 0) {
                    for(var j=0; j<item.data.clients.length; j++) {
                      if(item.data.clients[j] === this.state.id) {
                        num = j
                      }
                    }
                  }
                  var wgts = []
                  if(block.data.exResWeightGroup[i] !== undefined && block.data.exResWeightGroup[i] !== '') {
                    wgts = String(block.data.exResWeightGroup[i]).split('-')
                  }
                  var val2 = 0
                  var wnum = num
                  if(wgts[0] === '') {
                    wnum = num+1
                  }
                  if(wgts[wnum] !== '' && wgts[wnum] !== undefined) {
                    val2 = parseFloat(wgts[wnum])
                  }

                  var rps = []
                  if(block.data.exResRepsGroup[i] !== undefined && block.data.exResRepsGroup[i] !== '') {
                    rps = String(block.data.exResRepsGroup[i]).split('-')
                  }
                  var rps2 = 0
                  var rnum = num
                  if(rps[0] === '') {
                    rnum = num+1
                  }
                  if(rps[rnum] !== '' && rps[rnum] !== undefined) {
                    rps2 = parseFloat(rps[rnum])
                    valr = parseFloat(rps[rnum])
                  }

                  var name = lang.t('clients:label.groupsession')
                  if(item.data.client !== '') {
                    name = item.data.client
                  }
                  sessions.push({
                    id: item.id,
                    name: name,
                    type: block.data.type,
                    date: item.data.date,
                    weight: val2,
                    reps: rps2,
                    block: block,
                    weightType: block.data.exWeightType[i]
                  })
                  if(numbr > 1) {
                    label = ' ('+numbr+')'
                  }
                  var add = true
                  if(val === 0 && val2 === 0) {
                    add = false
                  }
                  if(add) {
                    tmp.push({
                      "x": Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('D MMM YYYY')+label,
                      "y": val2,
                    })
                    tmpr.push({
                      "x": Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('D MMM YYYY')+label,
                      "y": rps2,
                    })
                  }
                  
                }
              }
            }
          }
        }
      }
    }
    var tmp2 = []
    if(hasWeight) {
      tmp2 = [{
        "id": "W:",
        "color": "#1DC5C9",
        data: tmp
      },
      {
        "id": "R:",
        "color": "#81DB24",
        data: tmpr
      }]
    } else {
      tmp2 = [{
        "id": "Value:",
        "color": "#1DC5C9",
        data: tmpr
      }]
    }

    

    if(hasWeight) {
      if(this.state.showWeight && !this.state.showReps) {
        tmp2 = [{
          "id": "W:",
          "color": "#1DC5C9",
          data: tmp
        }]
      } else if(!this.state.showWeight && this.state.showReps) {
        tmp2 = [{
          "id": "R:",
          "color": "#81DB24",
          data: tmpr
        }]
      } else if(!this.state.showWeight && !this.state.showReps) {
        tmp2 = [{
          "id": "japan",
          "color": "#1DC5C9",
          "data": []
        }]
      }
    }

    setTimeout(() => {
      this.setState({
        dataLeft: tmp2,
        days: days,
        selected: sessions
      });
      EventEmitter.dispatch('graphLoaded', 'loaded');
    }, 100);

    global.dataWeight = tmp
  }


  updateRight(event) {
    this.setState({
      currentRight: event.target.value,
      dataRight: [
        {
          "id": "japan",
          "color": "#81DB24",
          "data": []
        },
      ],
    })
  }


  createGraphEnergy() {
    if(this.state.item !== null) {
      var tmp = []
      var tmpb1 = 0
      var tmpb2 = 0
      var tmpa1 = 0
      var tmpa2 = 0
      var list = this.state.sessions
      list.sort((a,b) => Moment(a.data.date, 'DD/MM/YYYY HH:mm') - Moment(b.data.date, 'DD/MM/YYYY HH:mm'));
      for(var item of list) {
        var val = 0
        var val2 = 0
        if(item.data.energyStart !== undefined) {
          var ar = item.data.energyStart.split('-')
          ar.splice(0,1)
          if(item.data.group) {
            if(item.data.clients.length > 0) {
              for(var i1=0; i1<item.data.clients.length; i1++) {
                if(item.data.clients[i1] === this.state.id) {
                  val = parseInt(ar[i1])
                }
              }
            }
          } else {
            val = parseInt(ar[0])
          }
        }

        var date = Moment(item.data.date, 'DD/MM/YYYY HH:mm')
        var min = Moment().add(-30, 'days')
        if(this.state.dateRange === '7days') {
          min = Moment().add(-7, 'days')
        }
        if(this.state.dateRange === '60days') {
          min = Moment().add(-60, 'days')
        }
        if(this.state.dateRange === 'month') {
          var mon = Moment().format('MM/YYYY')
          min = Moment('01/'+mon, 'DD/MM/YYYY')
        }
        if(this.state.dateRange === 'all') {
          min = Moment('01/01/1900', 'DD/MM/YYYY')
        }
        if(item.data.energyEnd !== undefined && date >= min) {
          var ar2 = item.data.energyEnd.split('-')
          ar2.splice(0,1)
          if(item.data.group) {
            if(item.data.clients.length > 0) {
              for(var i2=0; i2<item.data.clients.length; i2++) {
                if(item.data.clients[i2] === this.state.id) {
                  val2 = parseInt(ar2[i2])
                }
              }
            }
          } else {
            val2 = parseInt(ar2[0])
          }
        }
        
        if(val !== 0 && val2 !== 0) {
          tmp.push({
            "date": Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('DD/MM'),
            "before": val,
            "after": val2
          })
          tmpb1 += val
          tmpb2++
          tmpa1 += val2
          tmpa2++
        }
      }
      var tmp2 = [{
        "id": "Before",
        "color": "#1DC5C9",
        data: tmp
      }]

      var e1 = '-'
      var e2 = '-'
      if(tmpb1 !== 0 && tmpb2 !== 0) {
        e1 = (tmpb1/tmpb2).toFixed(1)
      }
      if(tmpa1 !== 0 && tmpa2 !== 0) {
        e2 = (tmpa1/tmpa2).toFixed(1)
      }

      setTimeout(() => {
        this.setState({
          dataEnergy: tmp2,
          energy1: e1,
          energy2: e2
        });
      }, 100);
    }
  }



  // Movements ------------------------------------------------------------



  selectExercise(item) {
    this.setState({
      current: item,
      exid: item.id,
      exname: item.name,
      showSearch: false,
    }, () => {
      this.createGraphWeights(item.id)
    })
  }


  getBlockInfo(block) {
    var label = lang.t(global.proTypes[block.data.type])+' - '+block.data.rounds+' '+(block.data.rounds === 1 ? 'set' : 'sets')
    if(block.data.type === 0) {
      var t11 = Math.floor(block.data.rounds/60)
      var t12 = block.data.rounds-(t11*60)
      label = lang.t(global.proTypes[block.data.type])+' - '+t11+':'+(t12 < 10 ? '0' : '')+t12+'min Cap'
    }
    if(block.data.type === 1 || block.data.type === 2) {
      label = lang.t(global.proTypes[block.data.type])+' - '+block.data.rounds+' '+(block.data.rounds === 1 ? 'round' : 'rounds')
    }
    if(block.data.type === 3) {
      label = lang.t(global.proTypes[block.data.type])
      if(block.data.rounds > 0) {
        label = lang.t(global.proTypes[block.data.type])+' - '+block.data.rounds+' '+(block.data.rounds === 1 ? 'round' : 'rounds')
      }
    }
    if(block.data.type === 5) {
      var t1 = Math.floor(block.data.rounds/60)
      var t2 = block.data.rounds-(t1*60)
      label = lang.t(global.proTypes[block.data.type])+' - '+t1+':'+(t2 < 10 ? '0' : '')+t2+'min '+' - '+block.data.cycles+' rounds'
      if(block.data.cycles < 2) {
        label = lang.t(global.proTypes[block.data.type])+' - '+t1+':'+(t2 < 10 ? '0' : '')+t2+'min'
      }
    }
    return label
  }


  getWeightReps(block, pos, client) {
    var label = ''
    if(block.data.exReps[pos] > 0) {
      label = block.data.exReps[pos]+' reps'
      if(block.data.exReps[pos] === 1) {
        label = block.data.exReps[pos]+' rep'
      }
    }
    if(client === 99999 && block.exResReps !== undefined) {
      if(block.data.exResReps[pos] > 0) {
        label = block.data.exResReps[pos]+' reps'
        if(block.data.exResReps[pos] === 1) {
        label = block.data.exResReps[pos]+' rep'
      }
      }
    } else {
      if(block.data.exResRepsGroup !== undefined) {
        if(block.data.exResRepsGroup.length > pos) {
          var ar = block.data.exResRepsGroup[pos].split('-')
          if(ar[client] > 0) {
            label = ar[client]+' reps'
            if(ar[client] === 1) {
              label = ar[client]+' rep'
            }
          }
        }
      }
    }
    if(block.data.exWeightType[pos] !== 'kg' && block.data.exWeightType[pos] !== 'lb' && block.data.exWeight[pos] > 0) {
      if(label === '') {
        label += 'At '+block.data.exWeight[pos]+'%'
      } else {
        label += ' at '+block.data.exWeight[pos]+'%'
      }
      
    }
    if(label !== '') {
      label += ' - '
    }
    return label
  }


  normalizeWeight(val, type) {
    var value = val
    if(global.spaceLbs && type == 'kg') {
      value = val*2.2046
    }
    if(global.spaceLbs && type == 'lb') {
      value = val/2.2046
    }
    return value
  }


  getWeight(type) {
    var label = '-'
    var value = 0
    var lastinfo = ''
    var date = parseInt(Moment('01/01/1990', 'DD/MM/YYYY').format('X'))
    if(type === '1rmtitle') { label = '1RM' }
    if(type === 'heaviestsmall' || type === '1rmsmall' || type === 'averagesmall') { label = '' }
    var total = 0
    var totalr = 0
    var number = 0

    // 1RMs
    for(var item of global.clientBest) {
      if(item.client === this.state.item.data.uid && item.id === this.state.current.id) {
        if(type === 'heaviest') {
          value = this.normalizeWeight(item.data.actual-1, item.data.type)
          label = item.data.actual+item.data.type
        }
        if(type === 'heaviestsmall') {
          label = item.data.actual+item.data.type
          if(item.data.percent > 0) {
            label = 'With '+item.data.percent+'%\n'+Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
          } else {
            label = Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
          }
          
        }
        if(type === '1rm') {
          label = item.data.value+item.data.type
        }
        if(type === '1rmsmall') {
          label = Moment(item.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
          if(item.data.actual !== item.data.value) {
            label = 'Based on heaviest weight'
          }
        }
        if(type === '1rmtitle') {
          label = 'Calculated 1RM'
          if(item.data.actual === item.data.value) {
            label = '1RM'
          }
        }
      }
    }
    
    // Sessions
    for(var item1 of this.state.sessions) {
      if(item1.program.length > 0) {
        var clients = []
        if(item1.data.clients !== undefined) { clients = item1.data.clients }
        if(item1.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
          
          for(var block1 of item1.program[0].blocks) {
            if(block1.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos = 0
              for(var i=0; i<block1.data.exId.length; i++) {
                if(block1.data.exId[i] === this.state.current.id) {
                  pos = i
                }
              }

              if((type === 'last' || type === 'lastdate') && parseInt(item1.data.timestamp) >= parseInt(date)) {
                label = '0'+(global.spaceLbs ? 'lb' : 'kg')
                date = Moment(item1.data.timestamp, 'X').format('X')
                lastinfo = this.getWeightReps(block1, pos, 99999)+this.getBlockInfo(block1)
              }

              var u1 = (global.spaceLbs ? 'lb' : 'kg')
              if(block1.data.exWeightType !== undefined) {
                if(block1.data.exWeightType[pos] !== 'per') {
                  u1 = block1.data.exWeightType[pos]
                }
              }

              // Group
              if(item1.data.group && block1.data.exResWeightGroup !== undefined && item1.data.clients !== undefined) {
                if(item1.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client1 = 0
                  for(var j1=0; j1<item1.data.clients.length; j1++) {
                    if(item1.data.clients[j1] === this.state.item.id) {
                      client1 = j1
                    }
                  }
                  
                  if(block1.data.exResWeightGroup.length > pos) {
                    var ar1 = block1.data.exResWeightGroup[pos].split('-')
                    if(parseFloat(ar1[client1]) >= value && (type === 'heaviest' || type === 'heaviestsmall')) {
                      label = ar1[client1]+u1
                      value = this.normalizeWeight(parseFloat(ar1[client1]), u1)
                      if(type === 'heaviestsmall') {
                        label = this.getWeightReps(block1, pos, client1)+this.getBlockInfo(block1)+'\n'+Moment(item1.data.timestamp, 'X').format('ddd, D MMM YYYY')
                      }
                    }
                    if(type === 'last' && parseInt(item1.data.timestamp) >= parseInt(date)) {
                      label = ar1[client1]+u1
                    }
                    if((type === 'average' || type === 'averagesmall')) {
                      var ar2 = block1.data.exResRepsGroup[pos].split('-')
                      if(ar2.length > client1) {
                        if(ar2[client1] > 0) {
                          totalr += parseInt(ar2[client1])
                        } else {
                          totalr += block1.data.exReps[pos]
                        }
                      } else {
                        totalr += block1.data.exReps[pos]
                      }
                      if(ar1[client1] > 0) {
                      total += this.normalizeWeight(parseFloat(ar1[client1]), u1)
                      }
                      number++
                    }
                  }
                }
              // 1:1
              } else if(!item1.data.group && block1.data.exResWeight !== undefined && item1.data.client === this.state.item.id) {
                if(block1.data.exResWeight.length > pos) {
                  if(block1.data.exResWeight[pos] >= value && (type === 'heaviest' || type === 'heaviestsmall')) {
                    label = block1.data.exResWeight[pos]+u1
                    value = this.normalizeWeight(block1.data.exResWeight[pos], u1)
                    if(type === 'heaviestsmall') {
                      label = this.getWeightReps(block1, pos, 99999)+this.getBlockInfo(block1)+'\n'+Moment(item1.data.timestamp, 'X').format('ddd, D MMM YYYY')
                    }
                  }
                  if(type === 'last' && parseInt(item1.data.timestamp) >= parseInt(date)) {
                    label = block1.data.exResWeight[pos]+u1
                  }
                  if((type === 'average' || type === 'averagesmall')) {
                    if(block1.data.exResWeight[pos] > 0) {
                      total += this.normalizeWeight(block1.data.exResWeight[pos], u1)
                    }
                    if(block1.data.exResReps[pos] > 0) {
                      totalr += block1.data.exResReps[pos]
                    } else {
                      totalr += block1.data.exReps[pos]
                    }
                    number++
                  }
                }
              }
            }
          }
        }
      }
    }
    /*// Archive
    for(var item2 of global.archive) {
      if(item2.program.length > 0) {
        var clients = []
        if(item2.data.clients !== undefined) { clients = item2.data.clients }
        if(item2.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
          
          for(var block2 of item2.program[0].blocks) {
            if(block2.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos2 = 0
              for(var i2=0; i2<block2.data.exId.length; i2++) {
                if(block2.data.exId[i2] === this.state.current.id) {
                  pos2 = i
                }
              }

              var u2 = (global.spaceLbs ? 'lb' : 'kg')
              if(block2.data.exWeightType !== undefined) {
                if(block2.data.exWeightType[pos2] !== 'per') {
                  u2 = block2.data.exWeightType[pos2]
                }
              }

              if((type === 'last' || type === 'lastdate') && parseInt(item2.data.timestamp) > parseInt(date)) {
                label = '0kg'
                date = Moment(item2.data.timestamp, 'X').format('X')
                lastinfo = this.getWeightReps(block2, pos2, 99999)+this.getBlockInfo(block2)
              }

              // Group
              if(item2.data.group && block2.data.exResWeightGroup !== undefined && item2.data.clients !== undefined) {
                if(item2.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client2 = 0
                  for(var j2=0; j2<item2.data.clients.length; j2++) {
                    if(item2.data.clients[j2] === this.state.item.id) {
                      client2 = j2
                    }
                  }
                  
                  if(block2.data.exResWeightGroup.length > pos2) {
                    var ar21 = block2.data.exResWeightGroup[pos2].split('-')
                    if(parseFloat(ar21[client2]) >= value && (type === 'heaviest' || type === 'heaviestsmall')) {
                      label = ar21[client2]+u2
                      value = this.normalizeWeight(parseFloat(ar21[client2]), u2)
                      if(type === 'heaviestsmall') {
                        label = this.getWeightReps(block2, pos2, client2)+this.getBlockInfo(block2)+'\n'+Moment(item2.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
                      }
                    }
                    if(type === 'last' && parseInt(item2.data.timestamp) > parseInt(date)) {
                      label = ar21[client2]+u2
                    }
                    if((type === 'average' || type === 'averagesmall')) {
                      var ar22 = block2.data.exResRepsGroup[pos2].split('-')
                      if(ar22.length > client2) {
                        if(ar22[client2] > 0) {
                          totalr += parseInt(ar22[client2])
                        } else {
                          totalr += block1.data.exReps[pos2]
                        }
                      } else {
                        totalr += block1.data.exReps[pos2]
                      }
                      if(ar22[client2] > 0) {
                        total += this.normalizeWeight(parseFloat(ar22[client2]), u2)
                      }
                      number++
                    }
                  }
                }
              // 1:1
              } else if(!item2.data.group && block2.data.exResWeight !== undefined && item2.data.client === this.state.item.id) {
                if(block2.data.exResWeight.length > pos2) {
                  if(block2.data.exResWeight[pos2] >= value && type === 'heaviest' || type === 'heaviestsmall') {
                    label = block2.data.exResWeight[pos2]+u2
                    value = this.normalizeWeight(block2.data.exResWeight[pos2], u2)
                    if(type === 'heaviestsmall') {
                      label = this.getWeightReps(block2, pos2, 99999)+this.getBlockInfo(block2)+'\n'+Moment(item2.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
                    }
                  }
                  if(type === 'last' && parseInt(item2.data.timestamp) > parseInt(date)) {
                    label = block2.data.exResWeight[pos2]+u2
                  }
                  if((type === 'average' || type === 'averagesmall')) {
                    if(block2.data.exResWeight[pos2] > 0) {
                      total += this.normalizeWeight(block2.data.exResWeight[pos2], u2)
                    }
                    if(block2.data.exResReps[pos2] > 0) {
                      totalr += block2.data.exResReps[pos2]
                    } else {
                      totalr += block2.data.exReps[pos2]
                    }
                    number++
                  }
                }
              }
            }
          }
        }
      }
    }
    // Training
    for(var item3 of global.sessionsTraining) {
      if(item3.program.length > 0) {
        var clients = []
          
        for(var block3 of item3.program[0].blocks) {
          if(block3.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos3 = 0
            for(var i3=0; i3<block3.data.exId.length; i3++) {
              if(block3.data.exId[i3] === this.state.current.id) {
                pos3 = i
              }
            }

            var u3 = (global.spaceLbs ? 'lb' : 'kg')
            if(block3.data.exWeightType !== undefined) {
              if(block3.data.exWeightType[pos3] !== 'per') {
                u3 = block3.data.exWeightType[pos3]
              }
            }

            if((type === 'last' || type === 'lastdate') && parseInt(item3.data.timestamp) > parseInt(date)) {
              label = '0kg'
              date = Moment(item3.data.timestamp, 'X').format('X')
              lastinfo = this.getWeightReps(block3, pos3, 99999)+this.getBlockInfo(block3)
            }

            if(block3.data.exResWeight.length > pos3) {
              if(block3.data.exResWeight[pos3] >= value && type === 'heaviest' || type === 'heaviestsmall') {
                label = block3.data.exResWeight[pos3]+u3
                value = this.normalizeWeight(block3.data.exResWeight[pos3], u3)
                if(type === 'heaviestsmall') {
                  label = this.getWeightReps(block3, pos3, 99999)+this.getBlockInfo(block3)+'\n'+Moment(item3.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
                }
              }
              if(type === 'last' && parseInt(item3.data.timestamp) > parseInt(date)) {
                label = block3.data.exResWeight[pos3]+u3
              }
              if((type === 'average' || type === 'averagesmall')) {
                if(block3.data.exResWeight[pos3] > 0) {
                  total += this.normalizeWeight(block3.data.exResWeight[pos3], u3)
                }
                if(block3.data.exResReps[pos3] > 0) {
                  totalr += block3.data.exResReps[pos3]
                } else {
                  totalr += block3.data.exReps[pos3]
                }
                number++
              }
            }
          }
        }
      }
    }
    // Training archive
    for(var item4 of global.archiveTraining) {
      if(item4.program.length > 0) {
        var clients = []
          
        for(var block4 of item4.program[0].blocks) {
          if(block4.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos4 = 0
            for(var i4=0; i4<block4.data.exId.length; i4++) {
              if(block4.data.exId[i4] === this.state.current.id) {
                pos4 = i
              }
            }

            var u4 = (global.spaceLbs ? 'lb' : 'kg')
            if(block4.data.exWeightType !== undefined) {
              if(block4.data.exWeightType[pos4] !== 'per') {
                u4 = block4.data.exWeightType[pos4]
              }
            }

            if((type === 'last' || type === 'lastdate') && parseInt(item4.data.timestamp) > parseInt(date)) {
              label = '0kg'
              date = Moment(item4.data.timestamp, 'X').format('X')
              lastinfo = this.getWeightReps(block4, pos4, 99999)+this.getBlockInfo(block4)
            }

            if(block4.data.exResWeight.length > pos4) {
              if(block4.data.exResWeight[pos4] >= value && type === 'heaviest' || type === 'heaviestsmall') {
                label = block4.data.exResWeight[pos4]+u4
                value = this.normalizeWeight(block4.data.exResWeight[pos4], u4)
                if(type === 'heaviestsmall') {
                  label = this.getWeightReps(block4, pos4, 99999)+this.getBlockInfo(block4)+'\n'+Moment(item4.data.date, 'DD/MM/YYYY HH:mm').format('ddd, D MMM YYYY')
                }
              }
              if(type === 'last' && parseInt(item4.data.timestamp) > parseInt(date)) {
                label = block4.data.exResWeight[pos4]+u4
              }
              if((type === 'average' || type === 'averagesmall')) {
                if(block4.data.exResWeight[pos4] > 0) {
                  total += this.normalizeWeight(block4.data.exResWeight[pos4], u4)
                }
                if(block4.data.exResReps[pos4] > 0) {
                  totalr += block4.data.exResReps[pos4]
                } else {
                  totalr += block4.data.exReps[pos4]
                }
                number++
              }
            }
          }
        }
      }
    }*/

    if(type === 'lastdate') {
      if(Moment(date, 'X') > Moment('01/01/1990', 'DD/MM/YYYY')) {
        label = lastinfo+'\n'+Moment(date, 'X').format('ddd, D MMM YYYY')
      } else {
        label = ''
      }
    }
    if(type === 'average' && total > 0) {
      label = (total/number).toFixed(1)+'kg'
    }
    if(type === 'averagesmall' && totalr > 0) {
      label = 'With '+(totalr/number).toFixed(1)+' reps'
    }
    if(String(label).indexOf('NaN') !== -1 || String(label).indexOf('undefined') !== -1) {
      label = '-'
    }
    return label
  }


  getMax(type) {
    var label = '-'
    if(type === 'info') { label = '' }
    var unit = ' reps'
    var clients = []
    var value = 0
    if(type === 'smallest' || type === 'smallestinfo') {
      value = 999999
    }

    if(this.state.current.unit !== undefined && this.state.current.unit !== '') {
      if(this.state.current.unit === 'time' || this.state.current.tool == 28) {
        unit = 's'
      }
      if(this.state.current.unit === 'cal' || this.state.current.tool == 27) {
        unit = 'cal'
      }
      if(this.state.current.unit === 'dist' || this.state.current.tool == 6 || this.state.current.tool == 7 || this.state.current.tool == 25) {
        unit = 'm'
      }
    }

    for(var item1 of this.state.sessions) {
      if(item1.program.length > 0) {
        if(item1.data.clients !== undefined) { clients = item1.data.clients }
        if(item1.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
          
          for(var block1 of item1.program[0].blocks) {
            if(block1.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos = 0
              for(var i=0; i<block1.data.exId.length; i++) {
                if(block1.data.exId[i] === this.state.current.id) {
                  pos = i
                }
              }

              // Group
              if(item1.data.group && block1.data.exResRepsGroup !== undefined && item1.data.clients !== undefined) {
                if(item1.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client1 = 0
                  for(var j1=0; j1<item1.data.clients.length; j1++) {
                    if(item1.data.clients[j1] === this.state.item.id) {
                      client1 = j1
                    }
                  }
                  
                  if(block1.data.exResRepsGroup.length > pos) {
                    var ar1 = block1.data.exResRepsGroup[pos].split('-')
                    if((parseFloat(ar1[client1]) >= value && type !== 'smallest' && type !== 'smallestinfo') || (parseFloat(ar1[client1]) <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                      if(ar1[client1] > 0) {
                        label = ar1[client1]+unit
                        value = parseFloat(ar1[client1])
                        if(type.indexOf('info') !== -1) {
                          label = this.getBlockInfo(block1)+'\n'+Moment(item1.data.timestamp, 'X').format('ddd, D MMM YYYY')
                        }
                      }
                    }
                  }
                }
              // 1:1
              } else if(!item1.data.group && block1.data.exResReps !== undefined && item1.data.client === this.state.item.id) {
                if(block1.data.exResReps.length > pos) {
                  if((block1.data.exResReps[pos] >= value && type !== 'smallest' && type !== 'smallestinfo') || (block1.data.exResReps[pos] <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                    if(block1.data.exResReps[pos] > 0) {
                      label = block1.data.exResReps[pos]+unit
                      value = block1.data.exResReps[pos]
                      if(type.indexOf('info') !== -1) {
                        label = this.getBlockInfo(block1)+'\n'+Moment(item1.data.timestamp, 'X').format('ddd, D MMM YYYY')
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
    /*// Archive
    for(var item2 of global.archive) {
      if(item2.program.length > 0) {
        if(item2.data.clients !== undefined) { clients = item2.data.clients }
        if(item2.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
          
          for(var block2 of item2.program[0].blocks) {
            if(block2.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos2 = 0
              for(var i2=0; i2<block2.data.exId.length; i2++) {
                if(block2.data.exId[i2] === this.state.current.id) {
                  pos2 = i2
                }
              }

              // Group
              if(item2.data.group && block2.data.exResRepsGroup !== undefined && item2.data.clients !== undefined) {
                if(item2.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client2 = 0
                  for(var j2=0; j2<item2.data.clients.length; j2++) {
                    if(item2.data.clients[j2] === this.state.item.id) {
                      client2 = j2
                    }
                  }
                  
                  if(block2.data.exResRepsGroup.length > pos2) {
                    var ar2 = block2.data.exResRepsGroup[pos2].split('-')
                    if((parseFloat(ar2[client2]) >= value && type !== 'smallest' && type !== 'smallestinfo') || (parseFloat(ar2[client2]) <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                      if(ar2[client2] > 0) {
                        label = ar2[client2]+unit
                        value = parseFloat(ar2[client2])
                        if(type.indexOf('info') !== -1) {
                          label = this.getBlockInfo(block2)+'\n'+Moment(item2.data.timestamp, 'X').format('ddd, D MMM YYYY')
                        }
                      }
                    }
                  }
                }
              // 1:1
              } else if(!item2.data.group && block2.data.exResReps !== undefined && item2.data.client === this.state.item.id) {
                if(block2.data.exResReps.length > pos2) {
                  if((block2.data.exResReps[pos2] >= value && type !== 'smallest' && type !== 'smallestinfo') || (block2.data.exResReps[pos2] <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                    if(block2.data.exResReps[pos2] > 0) {
                      label = block2.data.exResReps[pos2]+unit
                      value = block2.data.exResReps[pos2]
                      if(type.indexOf('info') !== -1) {
                        label = this.getBlockInfo(block2)+'\n'+Moment(item2.data.timestamp, 'X').format('ddd, D MMM YYYY')
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
    }
    // Training
    for(var item3 of global.sessionsTraining) {
      if(item3.program.length > 0) {
          
        for(var block3 of item3.program[0].blocks) {
          if(block3.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos3 = 0
            for(var i3=0; i3<block3.data.exId.length; i3++) {
              if(block3.data.exId[i3] === this.state.current.id) {
                pos3 = i3
              }
            }

            if(block3.data.exResReps.length > pos3) {
              if((block3.data.exResReps[pos3] >= value && type !== 'smallest' && type !== 'smallestinfo') || (block3.data.exResReps[pos3] <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                if(block3.data.exResReps[pos3] > 0) {
                  label = block3.data.exResReps[pos3]+unit
                  value = block3.data.exResReps[pos3]
                  if(type.indexOf('info') !== -1) {
                    label = this.getBlockInfo(block3)+'\n'+Moment(item3.data.timestamp, 'X').format('ddd, D MMM YYYY')
                  }
                }
              }
            }
          }
        }
      }
    }
      // Training archive
    for(var item4 of global.archiveTraining) {
      if(item4.program.length > 0) {
          
        for(var block4 of item4.program[0].blocks) {
          if(block4.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos4 = 0
            for(var i4=0; i4<block4.data.exId.length; i4++) {
              if(block4.data.exId[i4] === this.state.current.id) {
                pos4 = i4
              }
            }

            if(block4.data.exResReps.length > pos4) {
              if((block4.data.exResReps[pos4] >= value && type !== 'smallest' && type !== 'smallestinfo') || (block4.data.exResReps[pos4] <= value && (type === 'smallest' || type === 'smallestinfo'))) {
                if(block4.data.exResReps[pos4] > 0) {
                  label = block4.data.exResReps[pos4]+unit
                  value = block4.data.exResReps[pos4]
                  if(type.indexOf('info') !== -1) {
                    label = this.getBlockInfo(block4)+'\n'+Moment(item3.data.timestamp, 'X').format('ddd, D MMM YYYY')
                  }
                }
              }
            }
          }
        }
      }
    }*/

    if(type === 'title') {
      label = 'Max reps'
      if(this.state.current.unit === 'dist') {
        label = 'Max distance'
      }
      if(this.state.current.unit === 'cal') {
        label = 'Max calories'
      }
      if(this.state.current.unit === 'time') {
        label = 'Max time'
      }
    }
    if(label.indexOf('NaN') !== -1 || String(label).indexOf('undefined') !== -1) {
      label = '-'
    }
    return label
  }


  getSecond(type) {
    var label = '-'
    if(type === 'info') { label = '' }
    var unit = ' reps'
    var clients = []
    var val1 = 0
    var val2 = 0
    if(this.state.current.unit !== undefined && this.state.current.unit !== '') {
      if(this.state.current.unit === 'time' || this.state.current.tool == 28) {
        unit = 's'
      }
      if(this.state.current.unit === 'cal' || this.state.current.tool == 27) {
        unit = 'cal'
      }
      if(this.state.current.unit === 'dist' || this.state.current.tool == 6 || this.state.current.tool == 7 || this.state.current.tool == 25) {
        unit = 'm'
      }
    }
    if((unit === 'm' || unit === 'cal') && type === 'value') {
      for(var item1 of this.state.sessions) {
        if(item1.program.length > 0) {
          if(item1.data.clients !== undefined) { clients = item1.data.clients }
          if(item1.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
            
            for(var block1 of item1.program[0].blocks) {
              if(block1.data.exId.indexOf(this.state.current.id) !== -1 && block1.data.exId.length === 1) {
                // Group
                if(item1.data.group && block1.data.exResRepsGroup !== undefined && item1.data.clients !== undefined) {
                  if(item1.data.clients.indexOf(this.state.item.id) !== -1) {
                    var client1 = 0
                    for(var j1=0; j1<item1.data.clients.length; j1++) {
                      if(item1.data.clients[j1] === this.state.item.id) {
                        client1 = j1
                      }
                    }
                    if(block1.data.exResRepsGroup.length > 0) {
                      var ar1 = block1.data.exResRepsGroup[0].split('-')
                      //For time - fixed reps/time
                      if(block1.data.type === 5 && block1.data.timeResGroup !== undefined) {
                        if(block1.data.timeResGroup[client1] > 0) {
                          val1 += block1.data.exReps[0]
                          val2 += block1.data.timeResGroup[client1]
                        }
                      } else if(block1.data.type !== 4 && block1.data.type !== 5 && ar1[client1] > 0) {
                        //Amrap - total reps/rounds (ie fixed time)
                        if(block1.data.type === 0) {
                          val1 += parseFloat(ar1[client1])
                          val2 += block1.data.rounds
                        }
                        //Intervals & EMOM - total reps/rounds*work per round
                        if(block1.data.type === 1 || block1.data.type === 2) {
                          val1 += parseFloat(ar1[client1])/block1.data.rounds
                          val2 += block1.data.exWork[0]
                        }
                        //Tabata
                        if(block1.data.type === 3) {
                          val1 += parseFloat(ar1[client1])/block1.data.rounds
                          val2 += 20
                        }
                      }
                    }
                  }
                // 1:1
                } else if(!item1.data.group && block1.data.exResReps !== undefined && item1.data.client === this.state.item.id) {
                  if(block1.data.exResReps.length > 0) {
                    //For time - fixed reps/time
                    if(block1.data.type === 5 && block1.data.timeRes !== undefined) {
                      if(block1.data.timeRes > 0) {
                        val1 += block1.data.exReps[0]
                        val2 += block1.data.timeRes
                      }
                    } else if(block1.data.type !== 4 && block1.data.type !== 5 && block1.data.exResReps[0] > 0) {
                      //Amrap - total reps/rounds (ie fixed time)
                      if(block1.data.type === 0) {
                        val1 += block1.data.exResReps[0]
                        val2 += block1.data.rounds
                      }
                      //Intervals & EMOM - total reps/rounds*work per round
                      if(block1.data.type === 1 || block1.data.type === 2) {
                        val1 += block1.data.exResReps[0]/block1.data.rounds
                        val2 += block1.data.exWork[0]
                      }
                      //Tabata
                      if(block1.data.type === 3) {
                        val1 += block1.data.exResReps[0]/block1.data.rounds
                        val2 += 20
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      /*// Archive
      for(var item2 of global.archive) {
        if(item2.program.length > 0) {
          if(item2.data.clients !== undefined) { clients = item2.data.clients }
          if(item2.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {
            
            for(var block2 of item2.program[0].blocks) {
              if(block2.data.exId.indexOf(this.state.current.id) !== -1 && block2.data.exId.length === 1) {
                // Group
                if(item2.data.group && block2.data.exResRepsGroup !== undefined && item2.data.clients !== undefined) {
                  if(item2.data.clients.indexOf(this.state.item.id) !== -1) {
                    var client2 = 0
                    for(var j2=0; j2<item2.data.clients.length; j2++) {
                      if(item2.data.clients[j2] === this.state.item.id) {
                        client1 = j2
                      }
                    }
                    if(block2.data.exResRepsGroup.length > 0) {
                      var ar2 = block2.data.exResRepsGroup[0].split('-')
                      //For time - fixed reps/time
                      if(block2.data.type === 5 && block2.data.timeResGroup !== undefined) {
                        if(block2.data.timeResGroup[client2] > 0) {
                          val1 += block2.data.exReps[0]
                          val2 += block2.data.timeResGroup[client2]
                        }
                      } else if(block2.data.type !== 4 && block2.data.type !== 5 && ar2[client2] > 0) {
                        //Amrap - total reps/rounds (ie fixed time)
                        if(block2.data.type === 0) {
                          val1 += parseFloat(ar2[client2])
                          val2 += block2.data.rounds
                        }
                        //Intervals & EMOM - total reps/rounds*work per round
                        if(block2.data.type === 1 || block2.data.type === 2) {
                          val1 += parseFloat(ar2[client2])/block2.data.rounds
                          val2 += block2.data.exWork[0]
                        }
                        //Tabata
                        if(block2.data.type === 3) {
                          val1 += parseFloat(ar2[client2])/block2.data.rounds
                          val2 += 20
                        }
                      }
                    }
                  }
                // 1:1
                } else if(!item2.data.group && block2.data.exResReps !== undefined && item2.data.client === this.state.item.id) {
                  if(block2.data.exResReps.length > 0) {
                    //For time - fixed reps/time
                    if(block2.data.type === 5 && block2.data.timeRes !== undefined) {
                      if(block2.data.timeRes > 0) {
                        val1 += block2.data.exReps[0]
                        val2 += block2.data.timeRes
                      }
                    } else if(block2.data.type !== 4 && block2.data.type !== 5 && block2.data.exResReps[0] > 0) {
                      //Amrap - total reps/rounds (ie fixed time)
                      if(block2.data.type === 0) {
                        val1 += block2.data.exResReps[0]
                        val2 += block2.data.rounds
                      }
                      //Intervals & EMOM - total reps/rounds*work per round
                      if(block2.data.type === 1 || block2.data.type === 2) {
                        val1 += block2.data.exResReps[0]/block2.data.rounds
                        val2 += block2.data.exWork[0]
                      }
                      //Tabata
                      if(block2.data.type === 3) {
                        val1 += block2.data.exResReps[0]/block2.data.rounds
                        val2 += 20
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      // Training
      for(var item3 of global.sessionsTraining) {
        if(item3.program.length > 0) {
            
          for(var block3 of item3.program[0].blocks) {
            if(block3.data.exId.indexOf(this.state.current.id) !== -1 && block3.data.exId.length === 1) {
              if(block3.data.exResReps.length > 0) {
                //For time - fixed reps/time
                if(block3.data.type === 5 && block3.data.timeRes !== undefined) {
                  if(block3.data.timeRes > 0) {
                    val1 += block3.data.exReps[0]
                    val2 += block3.data.timeRes
                  }
                } else if(block3.data.type !== 4 && block3.data.type !== 5 && block3.data.exResReps[0] > 0) {
                  //Amrap - total reps/rounds (ie fixed time)
                  if(block3.data.type === 0) {
                    val1 += block3.data.exResReps[0]
                    val2 += block3.data.rounds
                  }
                  //Intervals & EMOM - total reps/rounds*work per round
                  if(block3.data.type === 1 || block3.data.type === 2) {
                    val1 += block3.data.exResReps[0]/block3.data.rounds
                    val2 += block3.data.exWork[0]
                  }
                  //Tabata
                  if(block3.data.type === 3) {
                    val1 += block3.data.exResReps[0]/block3.data.rounds
                    val2 += 20
                  }
                }
              }
            }
          }
        }
      }
      // Training archive
      for(var item4 of global.archiveTraining) {
        if(item4.program.length > 0) {
            
          for(var block4 of item4.program[0].blocks) {
            if(block4.data.exId.indexOf(this.state.current.id) !== -1 && block4.data.exId.length === 1) {
              if(block4.data.exResReps.length > 0) {
                //For time - fixed reps/time
                if(block4.data.type === 5 && block4.data.timeRes !== undefined) {
                  if(block4.data.timeRes > 0) {
                    val1 += block4.data.exReps[0]
                    val2 += block4.data.timeRes
                  }
                } else if(block4.data.type !== 4 && block4.data.type !== 5 && block4.data.exResReps[0] > 0) {
                  //Amrap - total reps/rounds (ie fixed time)
                  if(block4.data.type === 0) {
                    val1 += block4.data.exResReps[0]
                    val2 += block4.data.rounds
                  }
                  //Intervals & EMOM - total reps/rounds*work per round
                  if(block4.data.type === 1 || block4.data.type === 2) {
                    val1 += block4.data.exResReps[0]/block4.data.rounds
                    val2 += block4.data.exWork[0]
                  }
                  //Tabata
                  if(block4.data.type === 3) {
                    val1 += block4.data.exResReps[0]/block4.data.rounds
                    val2 += 20
                  }
                }
              }
            }
          }
        }
      }*/
    }

    if(type === 'title') {
      label = 'Least amount of reps'
      if(this.state.current.unit === 'dist') {
        label = 'Time per 1000m'
      }
      if(this.state.current.unit === 'cal') {
        label = 'Cals per hour'
      }
      if(this.state.current.unit === 'time') {
        label = 'Shortest time'
      }
    }
    if(unit === ' reps' || unit === 's') {
      if(type === 'value') {
        label = this.getMax('smallest')
      } else if(type === 'info') {
        label = this.getMax('smallestinfo')
      }
    } else if(unit === 'm' && type === 'value') {
      var final1 = val2/val1*1000
      label = final1.toFixed(1)+'m'
    } else if(unit === 'cal' && type === 'value') {
      var final2 = val2/val1*1000
      label = final2.toFixed(1)+'cal'
    }
    if(label.indexOf('NaN') !== -1 || String(label).indexOf('undefined') !== -1) {
      label = '-'
    }
    return label
  }


  getLast(type) {
    var label = '-'
    if(type === 'info') { label = '' }
    var unit = ' reps'
    var clients = []
    if(this.state.current.unit !== undefined && this.state.current.unit !== '') {
      if(this.state.current.unit === 'time' || this.state.current.tool == 28) {
        unit = 's'
      }
      if(this.state.current.unit === 'cal' || this.state.current.tool == 27) {
        unit = 'cal'
      }
      if(this.state.current.unit === 'dist' || this.state.current.tool == 6 || this.state.current.tool == 7 || this.state.current.tool == 25) {
        unit = 'm'
      }
    }

    for(var item1 of this.state.sessions) {
      if(item1.program.length > 0) {
        if(item1.data.clients !== undefined) { clients = item1.data.clients }
        if(item1.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {

          for(var block1 of item1.program[0].blocks) {
            if(block1.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos = 0
              for(var i=0; i<block1.data.exId.length; i++) {
                if(block1.data.exId[i] === this.state.current.id) {
                  pos = i
                }
              }

              label = '0'+unit
              if(type === 'info') {
                label = this.getBlockInfo(block1)+'\n'+Moment(item1.data.timestamp, 'X').format('ddd, D MMM YYYY')
              }

              // Group
              if(item1.data.group && block1.data.exResRepsGroup !== undefined && item1.data.clients !== undefined) {
                if(item1.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client1 = 0
                  for(var j1=0; j1<item1.data.clients.length; j1++) {
                    if(item1.data.clients[j1] === this.state.item.id) {
                      client1 = j1
                    }
                  }
                  
                  if(block1.data.exResRepsGroup.length > pos) {
                    var ar1 = block1.data.exResRepsGroup[pos].split('-')
                    if(type === 'value') {
                      label = ar1[client1]+unit
                    }
                  }
                }
              // 1:1
              } else if(!item1.data.group && block1.data.exResReps !== undefined && item1.data.client === this.state.item.id) {
                if(block1.data.exResReps.length > pos) {
                  if(type === 'value') {
                    label = block1.data.exResReps[pos]+unit
                  }
                }
              }
            }
          }

        }
      }
    }
    /*// Archive
    for(var item2 of global.archive) {
      if(item2.program.length > 0) {
        if(item2.data.clients !== undefined) { clients = item2.data.clients }
        if(item2.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {

          for(var block2 of item2.program[0].blocks) {
            if(block2.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos2 = 0
              for(var i2=0; i2<block2.data.exId.length; i2++) {
                if(block2.data.exId[i2] === this.state.current.id) {
                  pos2 = i2
                }
              }

              label = '0'+unit
              if(type === 'info') {
                label = this.getBlockInfo(block2)+'\n'+Moment(item2.data.timestamp, 'X').format('ddd, D MMM YYYY')
              }

              // Group
              if(item2.data.group && block2.data.exResRepsGroup !== undefined && item2.data.clients !== undefined) {
                if(item2.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client2 = 0
                  for(var j2=0; j2<item2.data.clients.length; j2++) {
                    if(item2.data.clients[j2] === this.state.item.id) {
                      client2 = j2
                    }
                  }
                  
                  if(block2.data.exResRepsGroup.length > pos2) {
                    var ar2 = block2.data.exResRepsGroup[pos2].split('-')
                    if(type === 'value') {
                      label = ar2[client2]+unit
                    }
                  }
                }
              // 1:1
              } else if(!item2.data.group && block2.data.exResReps !== undefined && item2.data.client === this.state.item.id) {
                if(block2.data.exResReps.length > pos2) {
                  if(type === 'value') {
                    label = block2.data.exResReps[pos2]+unit
                  }
                }
              }
            }
          }

        }
      }
    }
    // Training
    for(var item3 of global.sessionsTraining) {
      if(item3.program.length > 0) {

        for(var block3 of item3.program[0].blocks) {
          if(block3.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos3 = 0
            for(var i3=0; i3<block3.data.exId.length; i3++) {
              if(block3.data.exId[i3] === this.state.current.id) {
                pos3 = i3
              }
            }

            label = '0'+unit
            if(type === 'info') {
              label = this.getBlockInfo(block3)+'\n'+Moment(item3.data.timestamp, 'X').format('ddd, D MMM YYYY')
            }
            if(block3.data.exResReps.length > pos3) {
              if(type === 'value') {
                label = block3.data.exResReps[pos3]+unit
              }
            }
          }
        }
      }
    }
    // Training archive
    for(var item4 of global.archiveTraining) {
      if(item4.program.length > 0) {

        for(var block4 of item4.program[0].blocks) {
          if(block4.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos4 = 0
            for(var i4=0; i4<block4.data.exId.length; i4++) {
              if(block4.data.exId[i4] === this.state.current.id) {
                pos4 = i4
              }
            }

            label = '0'+unit
            if(type === 'info') {
              label = this.getBlockInfo(block4)+'\n'+Moment(item4.data.timestamp, 'X').format('ddd, D MMM YYYY')
            }
            if(block4.data.exResReps.length > pos4) {
              if(type === 'value') {
                label = block4.data.exResReps[pos4]+unit
              }
            }
          }
        }
      }
    }*/

    if(label.indexOf('NaN') !== -1 || String(label).indexOf('undefined') !== -1) {
      label = '-'
    }
    return label
  }


  getAverage(type) {
    var label = '-'
    var unit = ' reps'
    var clients = []
    var total = 0
    var number = 0
    if(this.state.current.unit !== undefined && this.state.current.unit !== '') {
      if(this.state.current.unit === 'time' || this.state.current.tool == 28) {
        unit = 's'
      }
      if(this.state.current.unit === 'cal' || this.state.current.tool == 27) {
        unit = 'cal'
      }
      if(this.state.current.unit === 'dist' || this.state.current.tool == 6 || this.state.current.tool == 7 || this.state.current.tool == 25) {
        unit = 'm'
      }
    }

    for(var item1 of this.state.sessions) {
      if(item1.program.length > 0) {
        if(item1.data.clients !== undefined) { clients = item1.data.clients }
        if(item1.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {

          for(var block1 of item1.program[0].blocks) {
            if(block1.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos = 0
              for(var i=0; i<block1.data.exId.length; i++) {
                if(block1.data.exId[i] === this.state.current.id) {
                  pos = i
                }
              }

              // Group
              if(item1.data.group && block1.data.exResRepsGroup !== undefined && item1.data.clients !== undefined) {
                if(item1.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client1 = 0
                  for(var j1=0; j1<item1.data.clients.length; j1++) {
                    if(item1.data.clients[j1] === this.state.item.id) {
                      client1 = j1
                    }
                  }
                  
                  if(block1.data.exResRepsGroup.length > pos) {
                    var ar1 = block1.data.exResRepsGroup[pos].split('-')
                    if(parseInt(ar1[client1]) > 0) {
                      total += parseInt(ar1[client1])
                      number++
                    }
                  }
                }
              // 1:1
              } else if(!item1.data.group && block1.data.exResReps !== undefined && item1.data.client === this.state.item.id) {
                if(block1.data.exResReps.length > pos) {
                  if(block1.data.exResReps[pos] > 0) {
                    total += block1.data.exResReps[pos]
                    number++
                  }
                  
                }
              }
            }
          }

        }
      }
    }
    /*// Archive
    for(var item2 of global.archive) {
      if(item2.program.length > 0) {
        if(item2.data.clients !== undefined) { clients = item2.data.clients }
        if(item2.data.client === this.state.item.id || clients.indexOf(this.state.item.id) !== -1) {

          for(var block2 of item2.program[0].blocks) {
            if(block2.data.exId.indexOf(this.state.current.id) !== -1) {
              var pos2 = 0
              for(var i2=0; i2<block2.data.exId.length; i2++) {
                if(block2.data.exId[i2] === this.state.current.id) {
                  pos2 = i2
                }
              }

              // Group
              if(item2.data.group && block2.data.exResRepsGroup !== undefined && item2.data.clients !== undefined) {
                if(item2.data.clients.indexOf(this.state.item.id) !== -1) {
                  var client2 = 0
                  for(var j2=0; j2<item2.data.clients.length; j2++) {
                    if(item2.data.clients[j2] === this.state.item.id) {
                      client2 = j2
                    }
                  }
                  
                  if(block2.data.exResRepsGroup.length > pos2) {
                    var ar2 = block2.data.exResRepsGroup[pos2].split('-')
                    if(parseInt(ar2[client2]) > 0) {
                      total += parseInt(ar2[client2])
                      number++
                    }
                  }
                }
              // 1:1
              } else if(!item2.data.group && block2.data.exResReps !== undefined && item2.data.client === this.state.item.id) {
                if(block2.data.exResReps.length > pos2) {
                  if(block2.data.exResReps[pos2] > 0) {
                    total += block2.data.exResReps[pos2]
                    number++
                  }
                  
                }
              }
            }
          }

        }
      }
    }
    // Training
    for(var item3 of global.sessionsTraining) {
      if(item3.program.length > 0) {
        for(var block3 of item3.program[0].blocks) {
          if(block3.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos3 = 0
            for(var i3=0; i3<block3.data.exId.length; i3++) {
              if(block3.data.exId[i3] === this.state.current.id) {
                pos3 = i3
              }
            }

            if(block3.data.exResReps.length > pos3) {
              if(block3.data.exResReps[pos3] > 0) {
                total += block3.data.exResReps[pos3]
                number++
              }
            }
          }
        }
      }
    }
    // Training archive
    for(var item4 of global.archiveTraining) {
      if(item4.program.length > 0) {
        for(var block4 of item4.program[0].blocks) {
          if(block4.data.exId.indexOf(this.state.current.id) !== -1) {
            var pos4 = 0
            for(var i4=0; i4<block4.data.exId.length; i4++) {
              if(block4.data.exId[i4] === this.state.current.id) {
                pos4 = i4
              }
            }

            if(block4.data.exResReps.length > pos4) {
              if(block4.data.exResReps[pos4] > 0) {
                total += block4.data.exResReps[pos4]
                number++
              }
            }
          }
        }
      }
    }*/

    label = (total/number).toFixed(1)+unit
    if(label.indexOf('NaN') !== -1 || String(label).indexOf('undefined') !== -1) {
      label = '-'
    }
    return label
  }



  // Day modal ------------------------------------------------------------



  showModalDay(item) {
    var tmp = []
    for(var sess of this.state.selected) {
      if(Moment(sess.date, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') === item) {
        tmp.push(sess)
      }
    }
    this.setState({
      showModalDay: true,
      day: item,
      dsessions: tmp,
    })
    setTimeout(() => {
      const height = this.divElement.clientHeight
      this.setState({
        hiddenDay: '',
        margin: -height/2
      });
    }, 100);
  }


  hideModalDay() {
    const height = this.divElement.clientHeight
    this.setState({
      hiddenDay: 'hidden',
      margin: -height/2+100
    })
    setTimeout(() => {
      this.setState({showModalDay: false});
    }, 500);
  }


  renderSetsName(item) {
    var label = ''
    var s = ''
    if(item.rounds > 1) {
      s = 's'
    }
    var label = lang.t('program:label.set'+s)
    if(item.exId.length > 1) {
      var prev = ''
      var multiple = true
      for(var ex of item.exId) {
        if(ex !== prev && prev !== '') {
          label = lang.t('program:label.superset'+s)
          multiple = false
        }
        if(ex === prev && prev !== '') {
          label = lang.t('program:label.dropset'+s)
        }
        prev = ex
      }
      if(multiple) {
        label = lang.t('program:label.dropset'+s)
      } else {
        label = lang.t('program:label.superset'+s)
      }
    }
    return label
  }


  renderBlockType(item) {
    var label = ''
    var s = ''
    if(item.rounds > 1) {
      s = 's'
    }
    if(item.type === 0) {
      label = ' - '+HelperCal.getDurationMin(item.rounds)
    }
    if(item.type === 1) {
      label = ' - '+item.rounds+' '+lang.t('program:label.round'+s)+' '+lang.t('program:label.of')+' '+HelperCal.getDurationMinAlt(parseInt(item.exWork[0]))
      if(item.emom) {
        label = ' - '+item.rounds+' '+lang.t('program:label.round'+s)+' '+lang.t('program:label.of')+' '+HelperCal.getDurationMinAlt(parseInt(item.exWork[0]))+' ('+lang.t('program:label.allatthesametime')+')'
      }
    }
    if(item.type === 2 || item.type === 3) {
      label = ' - '+item.rounds+' '+lang.t('program:label.rounds')
      if(item.rounds === 1) {
        label = ' - 1 '+lang.t('program:label.round')
      }
      if(item.type === 2 && item.emom) { 
        if(item.exRest[0] === 0) {
          label += ' '+lang.t('program:label.of')+' '+HelperCal.getDurationMinAlt(parseInt(item.exWork[0]))+' '+lang.t('program:label.worknorest')
        } else {
          label += ' '+lang.t('program:label.of')+' '+HelperCal.getDurationMinAlt(parseInt(item.exWork[0]))+' '+lang.t('program:label.workand')+' '+HelperCal.getDurationMin(parseInt(item.exRest[0]))+' '+lang.t('program:label.rest-s')
        }
      }
    }
    if(item.type === 4) {
      label = ' - '+item.rounds+' '+this.renderSetsName(item)
      if(item.rounds === 1) {
        label = ' - 1 '+this.renderSetsName(item)
      }
    }
    if(item.type === 5) {
      label = ' - '+HelperCal.getDurationMin(item.rounds)
      if(item.cycles > 1) {
        label = ' - '+item.cycles+' '+lang.t('program:label.rounds')+' - '+lang.t('program:label.cap')+': '+HelperCal.getDurationMin(item.rounds)
      }
    }
    return label
  }


  renderDayContent() {
    if(this.state.dsessions.length === 0) {
      return (
        <div className="empty small">
          {HelperEmpty.renderImage('graph')}
          <h4>{lang.t('modals:beep.text1')}<br/>{lang.t('modals:beep.text2')} {Moment(this.state.day, 'DD/MM/YYYY').locale(lang.language).format('D MMM YYYY')}</h4>
        </div>
      )
    } else {
      var list = this.state.dsessions
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="clear">
            {list.map(item => (
              <div key={item.id} className="mb-20">
                <h4 className="mb-10">{item.name}</h4>
                <p><strong>{lang.t(global.proTypes[item.type])} {this.renderBlockType(item.block.data)}</strong><br/>{item.weight} {item.weightType !== 'per' ? item.weightType : (global.spaceLbs ? 'lb' : 'kg')}<br/>{item.reps} reps<br/></p>
                <div className="clear"></div>
              </div>
            ))}
          </div>
        )
      } else {
        return (
          <div className="clear">
            {list.map(item => (
              <div key={item.id} className="mb-20">
                <h4 className="mb-10">{item.name}</h4>
                <p><strong>{lang.t(global.proTypes[item.type])} {this.renderBlockType(item.block.data)}</strong><br/>{item.reps}{this.state.current.unit}<br/></p>
                <div className="clear"></div>
              </div>
            ))}
          </div>
        )
      }
      
    }
  }


  renderModalDay() {
    if(this.state.showModalDay) {
      return (
        <div className={'overlay '+this.state.hiddenDay}>
          <div className="box auto" ref={ (divElement) => { this.divElement = divElement }} style={{marginTop: this.state.margin}}>
            <h2 className="mb-20 lft">{Moment(this.state.day, 'DD/MM/YYYY').locale(lang.language).format('D MMM YYYY')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hideModalDay()}>{lang.t('common:button.close')}</button>
            <div className="clear"></div>
            {this.renderDayContent()}
          </div>
        </div>
      )
    }
  }



  // Beep modal ------------------------------------------------------------



  showModalBeep() {
    this.setState({
      showModalBeep: true,
    })
    setTimeout(() => {
      const height = this.divElement.clientHeight
      this.setState({
        hiddenBeep: '',
        margin: -height/2
      });
    }, 100);
  }


  hideModalBeep() {
    const height = this.divElement.clientHeight
    this.setState({
      hiddenBeep: 'hidden',
      margin: -height/2+100
    })
    setTimeout(() => {
      this.setState({showModalBeep: false});
    }, 500);
  }


  renderModalBeep() {
    if(this.state.showModalBeep) {
      return (
        <div className={'overlay '+this.state.hiddenBeep}>
          <div className="box auto" ref={ (divElement) => { this.divElement = divElement }} style={{marginTop: this.state.margin}}>
            <h2 className="mb-20 lft">{lang.t('modals:beep.title')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hideModalBeep()}>{lang.t('common:button.close')}</button>
            <div className="clear"></div>
            <div className="col-5">
              <select value={this.state.beep1} onChange={event => this.updateBeep(0, event)}>
                {this.state.beep.map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
            <div className="col-2" style={{textAlign: 'center', paddingTop: '4px', fontSize: '24px'}}>:</div>
            <div className="col-5">
              <select value={this.state.beep2} onChange={event => this.updateBeep(1, event)}>
                {this.state.beep.map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
            <div className="sv-40 clear"></div>
            <button className="btn primary" onClick={() => this.saveBeep()}>{lang.t('common:button.savechanges')}</button>
          </div>
        </div>
      )
    }
  }


  updateBeep(num, event) {
    var tmp1 = this.state.beep1
    var tmp2 = this.state.beep2
    if(num === 0) {
      tmp1 = event.target.value
    } else {
      tmp2 = event.target.value
    }
    this.setState({
      beep1: tmp1,
      beep2: tmp2
    })
  }


  saveBeep() {
    this.hideModalBeep()
    Firebase.database().ref('/clients/'+global.uid+'/'+this.state.item.id).update({
      beep: this.state.beep1+':'+this.state.beep2
    }).then(() => {
      EventEmitter.dispatch('showMessage', lang.t('messaging:message.beeptestupdated'));
    }).catch((error)=>{
      EventEmitter.dispatch('showMessageError', error.message);
    })
  }



  // Display stuff ------------------------------------------------------------



  renderGraph() {
    if(this.state.dataLeft[0].id === 'japan') {
      return (
        <p className="empty">{lang.t('clients:empty.nodata')}</p>
      )
    } else if(this.state.dataLeft[0].data.length === 0 && this.state.dataLeft[0].id !== 'japan') {
      return (
        <div className="empty small">
          {HelperEmpty.renderImage('graph')}
          <h4>{lang.t('clients:empty.nodata.title')}</h4>
          <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('clients:empty.nodata.text1')}</p>
        </div>
      )
    } else if(this.state.dataLeft[0].data.length > 0 && this.state.dataLeft[0].id !== 'japan') {
      if(this.state.dataLeft[0].data.length < 16) {
        return (
          <WidgetChartGraph data={this.state.dataLeft} curve='linear'/>
        )
      } else {
        var length = this.state.dataLeft[0].data.length*75
        return (
          <div style={{width: '100%', overflowX: 'auto'}}>
            <div style={{width: length}}><WidgetChartGraph data={this.state.dataLeft} curve='linear'/></div>
          </div>
        )
      }
      
    }
  }


  renderGraphEnergy() {
    return <WidgetChartBar data={this.state.dataEnergy[0].data}/>
  }


  renderData1() {
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="info large col-3">
            <label>{lang.t('clients:label.heaviestweightdone')}</label>
            <p>{this.getWeight('heaviest')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getWeight('heaviestsmall')}</span>
          </div>
        )
      } else {
        return (
          <div className="info large col-3">
            <label>{this.getMax('title')}</label>
            <p>{this.getMax('value')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getMax('info')}</span>
          </div>
        )
      }
    }
  }


  renderData2() {
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="info large col-3">
            <label>{this.getWeight('1rmtitle')}</label>
            <p>{this.getWeight('1rm')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getWeight('1rmsmall')}</span>
          </div>
        )
      } else {
        return (
          <div className="info large col-3">
            <label>{this.getSecond('title')}</label>
            <p>{this.getSecond('value')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getSecond('info')}</span>
          </div>
        )
      }
    }
  }


  renderData3() {
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="info large col-3">
            <label>Last time done</label>
            <p>{this.getWeight('last')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getWeight('lastdate')}</span>
          </div>
        )
      } else {
        return (
          <div className="info large col-3">
            <label>Last time done</label>
            <p>{this.getLast('value')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getLast('info')}</span>
          </div>
        )
      }
    }
  }


  renderData4() {
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="info large col-3">
            <label>Average weight</label>
            <p>{this.getWeight('average')}</p>
            <span style={{fontSize: 11, whiteSpace: 'pre-wrap'}}>{this.getWeight('averagesmall')}</span>
          </div>
        )
      } else {
        return (
          <div className="info large col-3">
            <label>Average</label>
            <p>{this.getAverage('value')}</p>
          </div>
        )
      }
    }
  }


  renderEnergy() {
    if(this.state.item !== null) {
      if(this.state.dataEnergy[0].data.length === 0 || this.state.dataEnergy[0].id === 'japan') {
        return (
          <div className="chart clear">
            <div className="empty small">
              {HelperEmpty.renderImage('graph')}
              <h4>{lang.t('clients:empty.nodata.title')}</h4>
              <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('clients:empty.nodata.text2')}</p>
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <div className="chart clear">
              {this.renderGraphEnergy()}
            </div>
            <div className="sv-40"></div>
            <div className="col-6">
              <div className="info">
                <label>{lang.t('clients:label.avgbefore')}</label>
                <p>{this.state.energy1}</p>
              </div>
            </div>
            <div className="col-6">
              <div className="info">
                <label>{lang.t('clients:label.avgafter')}</label>
                <p>{this.state.energy2}</p>
              </div>
            </div>
            <div className="clear"></div>
          </div>
        )
      }
    } else {
      return (
        <div className="mb-50 clear">
          <div className="empty small">
            {HelperEmpty.renderImage('graph')}
            <h4>{lang.t('clients:empty.nodata.title')}</h4>
            <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('clients:empty.nodata.text2')}</p>
          </div>
        </div>
      )
    }
  }


  renderBeepText() {
    if(this.state.item !== null) {
      if(this.state.item.data.beep === undefined) {
        return '-'
      } else {
        return this.state.item.data.beep
      }
    } else {
      return '-'
    }
  }


  renderBeepButton() {
    if(HelperBusiness.getRoleIncl('trainer')) {
      return (
        <button className="btn tertiary edit rgt small" onClick={() => this.showModalBeep()}>{lang.t('common:button.edit')}</button>
      )
    }
  }


  getDayClass(item) {
    var label = 'weekday interactive pending lft'
    if(this.state.days.indexOf(item) !== -1) {
      label = 'weekday interactive active lft'
    }
    return label
  }


  renderCalendar() {
    var d1 = Moment('01/'+this.state.month, 'DD/MM/YYYY').format('d')
    var d2 = Moment('01/'+this.state.month, 'DD/MM/YYYY').endOf('month').format('D')
    var list1 = []
    var list2 = []
    if(parseInt(d1) === 0) {
      d1 = 7
    }
    for(var i1=1; i1<parseInt(d1); i1++) {
      list1.push('')
    }
    for(var i2=1; i2<(parseInt(d2)+1); i2++) {
      list2.push(Moment(i2+'/'+this.state.month, 'D/MM/YYYY').format('DD/MM/YYYY'))
    }
    return (
      <div className="calmini">
        <div className="calmini-header">
          <div className="arrow lft" onClick={() => this.setMonth('prev')}>‹</div>
          <h3 className="lft mb-20">{Moment('01/'+this.state.month, 'DD/MM/YYYY').locale(lang.language).format('MMMM YYYY')}</h3>
          <div className="arrow lft" onClick={() => this.setMonth('next')}>›</div>
          <div className="clear"></div>
        </div>
        {list1.map(item => (
          <div>
            <div className="weekday lft" key={item}></div>
          </div>
        ))}
        {list2.map((item,index) => (
          <div>
            <div className={this.getDayClass(item)} key={item} onClick={() => this.showModalDay(item)}>{index+1}</div>
          </div>
        ))}
      </div>
    )
  }


  renderBenchmark() {
    if(global.maxClients === 0) {
      if(this.state.benchmark.length > 0) {
        var list = this.state.benchmark
        list.sort((a, b) => a.data.name.localeCompare(b.data.name))
        return (
          <div className="col-9 clear">
            <div className="listheader">
              <ListHeader id='benchmark' number={this.state.benchmark.length}/>
              <div className="clear"></div>
            </div>
            {list.map(item => (
              <div className="box list simple highlight mb-10" key={item.id}>
                <Link to={'/clients/'+this.state.id+'/benchmark/'+item.id}>
                  <div className="col-7 col-12-768">
                    <div className={'icon lft '+HelperCal.getColor(item.data.time)}>
                      <p>{item.data.time}'</p>
                    </div>
                    <p className="lft"><strong>{item.data.name}</strong></p>
                    <div className="clear"></div>
                  </div>
                  <div className="col-3">
                    <p>{HelperCal.getDuration(item.data.time)}</p>
                  </div>
                  <div className="col-2">
                    <button className="btn tertiary small rgt">{lang.t('common:button.viewdetails')}</button>
                  </div>
                  <div className="clear"></div>
                </Link>
              </div>
            ))}
          </div>
        )
      } else {
        return (
          <div className="col-9 clear">
            <div className="listheader">
              <h3>{lang.t('header:title.benchmark')}</h3>
              <div className="clear"></div>
            </div>
            <ListEmpty id='nobenchmark' type='simple'/>
          </div>
        )
      }
    } else {
      if(this.state.benchmark.length > 0) {
        return (
          <div className="col-9 clear">
            <div className="listheader">
              <h3>{lang.t('header:title.benchmark')}</h3>
              <div className="clear"></div>
            </div>
            <ListEmpty id='nobenchmark2' type='simple'/>
          </div>
        )
      }
    }
  }


  renderExSearch() {
    if(this.state.showSearch) {
      var list1 = this.state.variations
      list1.sort((a,b) => a.name.localeCompare(b.name))
      if(list1.length === 0 && this.state.search !== '') {
        return (
          <div className="add-movement">
            <p className="empty">{lang.t('program:prog.nomovementsfound')}</p>
          </div>
        )
      } else {
        return (
          <div className="add-movement">
            {list1.map(item => (
              <div className="item" key={item.id} onClick={() => this.selectExercise(item)}>{item.name}</div>
            ))}
          </div>
        )
      }
    }
  }


  renderLegend() {
    if(this.state.current !== null) {
      if(global.exToolsWeight.indexOf(this.state.current.tool) !== -1) {
        return (
          <div className="rgt">
            <div style={{marginTop: 15}} onClick={() => this.toggleGraph('weight')} className={this.state.showWeight ? 'checkbox mr-20 lft active' : 'checkbox lft mr-20'}>
              <div className="check mr-10">
                <div className="inner"></div>
              </div>
              <p>{lang.t('clients:label.weight')}</p>
            </div>
            <div style={{marginTop: 15}} onClick={() => this.toggleGraph('reps')} className={this.state.showReps ?  'checkbox mt-5 lft mr-20 active' : 'checkbox lft mr-20'}>
              <div className="check mr-10">
                <div className="inner"></div>
              </div>
              <p>{lang.t('clients:label.reps')}</p>
            </div>
          </div>
        )
      }
    }
  }


  renderBase() {
    return (
      <div className={'theme-'+global.spaceTheme}>
        <div className="content withtabs">
          {HelperClients.getFamily(this.state.item)}
        
          <div className="col-12 mb-30">
            <div className="col-7">
              <input type="text" className="add progress" placeholder={'Type a movement name'} onFocus={() => this.setState({showSearch: true, variations: [], search: ''})} value={this.state.showSearch ? this.state.search : this.state.exname} onChange={(event) => this.filterExercises(event.target.value)}/>
              {this.renderExSearch()}
            </div>
            <div className="col-5">
              {this.renderLegend()}
            </div>
          </div>
          <div className="chart col-9 clear">
            {this.renderGraph()}
          </div>
          <div className="col-3">
            {this.renderCalendar()}
          </div>

          <div className="sv-40 clear"></div>
          {this.renderData1()}
          {this.renderData2()}
          {this.renderData3()}
          {this.renderData4()}

          <div className="sv-50 clear"></div>
          {this.renderBenchmark()}

          <div className="col-3">
            <div className="clear mb-50">
              <h3 className="mb-20">{lang.t('clients:label.beeptest')}</h3>
              <div className="clear info">
                <label>{lang.t('clients:label.beeptest')}{this.renderBeepButton()}</label>
                <p>{this.renderBeepText()}</p>
              </div>
            </div>
            <div className="mb-50">
              <h3 className="mb-20 mt-5 lft">{lang.t('header:title.energy')}</h3>
              <select className="small light rgt" style={{width:120}} onChange={event => this.setDateRange(event)} value={this.state.dateRange}>
                <option value='7days'>{lang.t('nav:stats.7days')}</option>
                <option value='30days'>{lang.t('nav:stats.30days')}</option>
                <option value='month'>{lang.t('nav:stats.month')}</option>
                <option value='60days'>{lang.t('nav:stats.60days')}</option>
              </select>
              {this.renderEnergy()}
              <div className="clear"></div>
            </div>
          </div>
          <div className="clear sv-40"></div>
          
        </div>
        <Header client={this.state.item} link={global.currentPage} active='progress' dates={true} date1={this.state.date1} date2={this.state.date2} setDate1={(event) => this.setDateStart(event)} setDate2={(event) => this.setDateEnd(event)} setDates={() => this.setDates()}/>
        <Navigation active='clients' />
        {this.renderModalBeep()}
        {this.renderModalDay()}
      </div>
    )
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['clients','program','common','nav','modals','messaging'])(withRouter(withAuthorization(condition)(ClientsProgressPage)));